import { css } from "styled-system/css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { FadeIn } from "@/components/ui/animated";
import { displayApiError } from "@/lib/client-safe-error";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const r = await fetch("/api/auth/forgot-password", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email.trim().toLowerCase() }),
    });
    setBusy(false);
    if (!r.ok) {
      const j = (await r.json().catch(() => ({}))) as { error?: string };
      setError(displayApiError(j.error, "No se pudo procesar la solicitud."));
      return;
    }
    setDone(true);
  }

  return (
    <main className={css({ minH: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bg: "#f4f6f8", p: "6" })}>
      <FadeIn>
        <div
          className={css({
            w: "100%",
            maxW: "420px",
            bg: "white",
            rounded: "xl",
            borderWidth: "1px",
            borderColor: "#e2e8f0",
            p: "8",
            boxShadow: "0 12px 40px rgba(15,23,42,0.06)",
          })}
        >
          <h1 className={css({ fontSize: "xl", fontWeight: "bold", color: "#0f172a", mb: "2" })}>Olvidé mi contraseña</h1>
          <p className={css({ fontSize: "sm", color: "#64748b", mb: "6", lineHeight: "1.5" })}>
            Si el correo existe en SFTURNOS, te enviamos un enlace para restablecerla.
          </p>
          {done ? (
            <p className={css({ fontSize: "sm", color: "#166534", mb: "4" })}>
              Listo. Revisá tu bandeja (y spam). El enlace vence en 48 horas.
            </p>
          ) : (
            <form onSubmit={(ev) => void onSubmit(ev)} className={css({ display: "flex", flexDir: "column", gap: "4" })}>
              <label className={css({ display: "flex", flexDir: "column", gap: "1.5", fontSize: "sm" })}>
                Email
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={css({
                    h: "11",
                    px: "3",
                    rounded: "lg",
                    borderWidth: "1px",
                    borderColor: "#dbe2ea",
                    fontSize: "sm",
                  })}
                />
              </label>
              {error ? <p className={css({ fontSize: "sm", color: "#b91c1c" })}>{error}</p> : null}
              <button
                type="submit"
                disabled={busy}
                className={css({
                  h: "11",
                  rounded: "lg",
                  fontWeight: "semibold",
                  bg: "#0f172a",
                  color: "white",
                  border: "none",
                  cursor: busy ? "wait" : "pointer",
                })}
              >
                {busy ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          )}
          <p className={css({ mt: "6", fontSize: "sm", textAlign: "center" })}>
            <Link to="/auth/login" className={css({ color: "#4f46e5", fontWeight: "semibold" })}>
              Volver al inicio de sesión
            </Link>
          </p>
        </div>
      </FadeIn>
    </main>
  );
}
